import * as React from "react";
import { Navbar } from "@/components/hud/Navbar";
import { Toaster } from "@/components/ui/sonner";
import { StageBackdrop } from "@/components/landing/StageBackdrop";

// Page shell: shared navbar + global cinematic backdrop (every page inherits it) + toasts.
export function Layout({
  children,
  backdrop = "soft",
}: {
  children: React.ReactNode;
  backdrop?: "full" | "soft";
}) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <div className="relative isolate min-h-[calc(100vh-68px)] overflow-x-clip">
        <StageBackdrop intensity={backdrop} />
        {children}
      </div>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}
